import "../forms.css";

const RadioInput = ({ options, id, value, setValue }) => {
  return (
    <>
      {options.map((option, i) => (
        <div key={i} className={"formInputCheckbox"}>
          <input
            type="radio"
            id={id}
            className={"formInput"}
            value={option}
            onChange={(e) => {
              setValue(e.currentTarget.value);
            }}
            checked={option === value}
            required
          />
          <label className={"formLabel"}>{option}</label>
        </div>
      ))}
    </>
  );
};

export default RadioInput;
